/* eslint-disable react/prop-types */
import React, { useContext } from "react";
import { Alert, Button, Card, Descriptions, Dropdown, Menu, Tag } from "antd";
import {
  DollarOutlined,
  DownloadOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import { replaceUrlByParams } from "../../utils/api";
import { PAGE, TIME_FORMAT } from "../../utils/constants";
import moment from "moment";
import { AppContext } from "../../App";

export function paymentMethodText(method) {
  switch (method) {
    case "cash":
      return "現金";
    case "cheque":
      return "支票";
    case "alipay":
      return "支付寶";
    case "fps":
      return "FPS轉數快";
    case "customHtml":
      return "其他付款方式";
    default:
      return "其他";
  }
}

export const PaymentSelectDropdown = ({ children }) => {
  let history = useHistory();
  const {
    appSetting: { paymentMethod, programId },
  } = useContext(AppContext);
  const paymentMenu = (
    <Menu>
      {paymentMethod.map(
        (methodId) =>
          !["cash", "cheque"].includes(methodId) && (
            <Menu.Item
              key={methodId}
              onClick={() =>
                history.push(
                  replaceUrlByParams(
                    methodId === "customHtml"
                      ? PAGE.CUSTOM_HTML
                      : `/app/:pid/${methodId}`,
                    {
                      ":pid": programId,
                    }
                  )
                )
              }
            >
              {paymentMethodText(methodId)}
            </Menu.Item>
          )
      )}
    </Menu>
  );

  return (
    <Dropdown trigger={["click"]} overlay={paymentMenu}>
      {children}
    </Dropdown>
  );
};

function PaymentStatusTemplate(props) {
  let history = useHistory();
  const { pid, id, canEdit, paymentData } = props;
  const portal = canEdit ? "admin" : "user";

  return (
    <>
      <Card
        title="付款狀態"
        extra={
          <>
            {canEdit ? (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <a
                onClick={() =>
                  history.push({
                    pathname: `${replaceUrlByParams(PAGE.ADMIN_PAYMENT_EDIT, {
                      ":pid": pid,
                      ":id": id,
                    })}`,
                    state: { paymentData: paymentData },
                  })
                }
              >
                <EditOutlined /> 編輯付款狀態
              </a>
            ) : (
              paymentData.status === "pending" && (
                <PaymentSelectDropdown>
                  <Button>
                    <DollarOutlined /> 付款
                  </Button>
                </PaymentSelectDropdown>
              )
            )}
            {paymentData.status === "paid" ? (
              <Button>
                <Link
                  to={`${replaceUrlByParams(PAGE.RECEIPT, {
                    ":portal": portal,
                    ":pid": pid,
                    ":id": id,
                  })}`}
                  target="_blank"
                >
                  <DownloadOutlined />
                  下載收據
                </Link>
              </Button>
            ) : null}
          </>
        }
      >
        <Descriptions column={2}>
          {paymentData.paymentNumber && (
            <Descriptions.Item label="付款編號">
              {paymentData.paymentNumber}
            </Descriptions.Item>
          )}
          <Descriptions.Item label="付款狀態">
            <Tag color={paymentData.status === "paid" ? "green" : "red"}>
              {paymentData.status === "paid" ? "已付款" : "待付款"}
            </Tag>
          </Descriptions.Item>
          {paymentData.paymentMethod && (
            <Descriptions.Item label="付款方式">
              {paymentMethodText(paymentData.paymentMethod)}
            </Descriptions.Item>
          )}
          <Descriptions.Item label="付款金額">{`HKD ${
            paymentData.paymentAmountInCents / 100
          }`}</Descriptions.Item>
          {paymentData.paymentTimestamp ? (
            <Descriptions.Item label="付款時間">
              {moment(paymentData.paymentTimestamp).format(TIME_FORMAT)}
            </Descriptions.Item>
          ) : null}
          {paymentData.remarks && (
            <Descriptions.Item label="備註">
              {paymentData.remarks}
            </Descriptions.Item>
          )}
        </Descriptions>
      </Card>
    </>
  );
}

export default PaymentStatusTemplate;
